var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gwnl-drawer-steps" }, [
    _c(
      "ul",
      { staticClass: "gwnl-drawer-steps__wrapper" },
      _vm._l(_vm.steps, function (item, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "step-item",
            class: [_vm.current === index ? "active" : ""],
          },
          [
            _vm.current <= index
              ? _c("span", { staticClass: "step-icon" }, [
                  _vm._v(_vm._s(index + 1)),
                ])
              : _c("span", { staticClass: "step-icon yxt-icon-check" }),
            _c(
              "span",
              {
                staticClass: "step-title standard-size-14",
                class: [
                  _vm.current === index ? "color-primary-6" : "color-gray-9",
                ],
              },
              [_vm._v(_vm._s(item.name))]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }